import { FC } from 'react';
// i18next
import { Trans, useTranslation } from 'react-i18next';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { appActions } from 'store/app/appSlice';
import { selectShowDisabledAccountDialog } from 'store/app/appSelectors';
// Layouts
import { Dialog, DialogTitle, DialogContent, DialogActions } from 'layouts/Dialog';
// Components
import { Button } from 'components/Buttons';

const AccountDisabledDialog:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(appActions.toggleDisabledAccountDialog());
  }

  const showDisabledAccountDialog = useAppSelector(selectShowDisabledAccountDialog)

  if (!showDisabledAccountDialog) return null;
  return (
    <Dialog size="sm" open={showDisabledAccountDialog} onClose={onClose}>
      <DialogTitle title={t('dialogs.accountDisabled.title')} onClose={onClose} />
      <DialogContent>
        <p className="text-white text-center text-lg">
          <Trans
            t={t}
            components={{
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              a: <a href="mailto:sales@quizwizards.com" className="text-primary" />
            }}
            i18nKey="dialogs.accountDisabled.content"
          />
        </p>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
        >{t('buttons.close')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default AccountDisabledDialog;
